import '@lego/connect-core-tokens';
import '@lego/connect-components-styles';
import '@lego/connect-theme-enterprise';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './../tailwind.css';
import { initializeFaro } from '@grafana/faro-web-sdk';
import { App } from './App';
import { faroConfig } from './faro-config';

if (import.meta.env.VITE_FARO_URL) {
  initializeFaro(faroConfig);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
